export const normalizeEvidenceItems = (reference, group) => {
  const items = [];
  const add = (item) => {
    if (!item || typeof item !== 'object') return;
    if (item.id && items.some((existing) => existing.id === item.id)) return;
    items.push(item);
  };

  if (Array.isArray(group)) group.forEach(add);
  else add(group);

  if (Array.isArray(reference)) reference.forEach(add);
  else add(reference);

  return items;
};

export const getEvidenceGroup = (visit, fieldName) => (
  visit?.evidenceGroups?.[fieldName] ||
  visit?.evidence_groups?.[fieldName] ||
  []
);

export const getEvidenceItemsForField = (visit, fieldName) => (
  normalizeEvidenceItems(visit?.evidence?.[fieldName], getEvidenceGroup(visit, fieldName))
);

export const evidenceIsImage = (reference) => {
  const contentType = String(reference?.contentType || reference?.content_type || '').toLowerCase();
  const url = String(reference?.fileUrl || reference?.url || '').toLowerCase();
  return contentType.startsWith('image/') || /\.(jpe?g|png|webp|gif|heic|heif)(\?|$)/i.test(url);
};

export const evidenceIsVideo = (reference) => {
  const contentType = String(reference?.contentType || reference?.content_type || '').toLowerCase();
  const url = String(reference?.fileUrl || reference?.url || '').toLowerCase();
  return contentType.startsWith('video/') || /\.(mp4|mov|webm)(\?|$)/i.test(url);
};
